import { EventEmitter, Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CARRIER_TABLE_INTERFACE } from '../../interfaces/carrier.interface';
import { HttpService } from '../http.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { FilerOverlayComponent } from '../../components/filer-overlay/filer-overlay.component';
import { MatDialog } from '@angular/material/dialog';
import { CONTACT_TABLE_INTERFACE } from '../../interfaces/contact.interface';
import { BIDPACK_TABLE_INTERFACE } from '../../interfaces/bidpack.interface';
import { FUEL_ESCALATOR_TABLE_INTERFACE, FUEL_PRICE_TABLE_INTERFACE } from '../../interfaces/fuel-escalator.interface';
import { RATE_AGREEMENT_TABLE } from '../../interfaces/rate-information.interface';
import { CARRIER_DISPLAY_AGREEMENT_COLUMNS } from '../../constants/carrier.constant';
import { CONTACT_DISPLAY_AGREEMENT_COLUMNS } from '../../constants/contact.constant';
import { BIDPACK_DISPLAY_AGREEMENT_COLUMNS } from '../../constants/bidpack.constant';
import { DISPLAY_AGREEMENT_COLUMNS } from '../../constants/agreement.constant';
import { FUEL_ESCALATOR_COLUMN_LIST } from '../../constants/fuel-escalator.constant';
// import { Workbook } from 'exceljs';
// import { saveAs } from '@progress/kendo-file-saver';

import * as XLSX from 'xlsx';
import { DeleteWarningComponent } from '../../components/delete-warning/delete-warning.component';
import { filter } from 'jszip';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';


@Injectable({
  providedIn: 'root'
})
export class TableService {

  public displayColumUpdate:EventEmitter<string> = new EventEmitter<string>();
  public contactDBSOurce:any;
  public carrierDBSOurce:any;
  public bidpackDBSource:any;
  public fuelEscalatorDBSource:any;
  bsConfig:Partial<BsDatepickerConfig>;
  public prevDataSource:any;
  rateTablePageCount = 10;
  fuelEsltrPageCount = 10;
  editfuelEsltrPageCount =5;
  bipackPageCount = 10;
  carrierPageCount = 10;
  contactPageCount = 10;
  public newFontSize:any;
  public newHeight:any;

  constructor( public httpService: HttpService, public _liveAnnouncer: LiveAnnouncer, public appService: AppService, private router: Router, public dialog: MatDialog) { 
    this.bsConfig = {
      dateInputFormat: 'DD/MM/YYYY',
      containerClass:'custom-1',
      showWeekNumbers: false,   
      displayMonths:1,  
      adaptivePosition: true,
      selectFromOtherMonth: false,
      dateCustomClasses: []
      // minDate: new Date(),   
    }
  }
  
  checkWithFilter(enclosingObj:any) {
    // this.prevDataSource = enclosingObj.dataSource.data;
    
    enclosingObj.dataColList?.forEach((i: string) => {
      enclosingObj.contactTableForm.get(i + "Filter")?.valueChanges.subscribe((value: any) => {
        let filterObject = enclosingObj?.contactTableForm.value;
        filterObject[i+"Filter"] = value;         
        Object.keys(filterObject).forEach(key => {
          if ((filterObject[key] === "all") &&((key ==="RateAgreementStatusFilter"|| key === 'FuelEscalatorFilter' 
            || key==='AutoExtensionFlagFilter' || key === 'StatusFilter' || key === 'ContactTypeFilter'|| key ==='BidPackStatusFilter'))) {
            filterObject[key] = "";
          }
          else if(filterObject[key] === null){
            filterObject[key]=""
          }
      });
        let filteredArray = this.filterData(enclosingObj.actualData.data, filterObject);        
        enclosingObj.dataSource.data = filteredArray;        
        // setTimeout(() => {
          enclosingObj.dataSource.sort = enclosingObj.sort;
          enclosingObj.dataSource.paginator = enclosingObj.paginator;
        // },0)
      })
    })
  }

  public filterData(dataArray:any, filterCriteria:any) {
    return dataArray.filter((item:any) => {
        return Object.keys(filterCriteria).every(key => {
            let filterValue = filterCriteria[key];
            if (filterValue === "") return true; // If filter is empty, skip
            let itemKey = key.replace("Filter", ""); // Get corresponding key in the data
            
            if (key === "EffectiveDateFilter" || key === "ExpiryDateFilter") {
              const startDate = new Date((filterCriteria[key]).split('@')[0]);
              const endDate = new Date((filterCriteria[key]).split('@')[1]);
              const itemDate = new Date(item[itemKey]);
              if (startDate && endDate && !isNaN(itemDate.getTime())) {
                return itemDate >= startDate && itemDate <= endDate; // Date is in range
              }
              return true; // Skip filtering if dates are invalid or missing
            }

            if (item[itemKey] && typeof item[itemKey] === 'string') {
              if(key === 'StatusFilter' || key === 'BidPackStatusFilter' || key ==='RateAgreementStatusFilter'){
                return this.onStatusFilter(item,itemKey,filterValue)
              }
              if ((key ==="RateAgreementStatusFilter"|| key === 'FuelEscalatorFilter' 
                || key==='AutoExtensionFlagFilter' || key === 'StatusFilter' || key === 'ContactTypeFilter' || key ==="BidPackStatusFilter")) {
                  if(item[itemKey]?.toLowerCase() === filterValue?.toLowerCase()){
                    return true;
                  }
                  else{
                    return false;
                  }
              }
                return item[itemKey]?.toLowerCase().includes(filterValue?.toLowerCase()); // Case insensitive partial match
            }
            else if (typeof item[itemKey] === "number" || typeof item[itemKey] === "boolean") {
              return item[itemKey].toString() === filterValue; // Exact match for numbers and booleans
            } 
            return item[itemKey] === filterValue; // Exact match for other types
        });
    });
}

  disablingDownload(enclosingObj:any){
    return enclosingObj.dataSource.data.filter((data:any)=>data.Selected).length ;
  }

  onStatusFilter(item:any,itemKey:any,filterValue:any){
    if(filterValue.includes('all')){
      return true;
    }
    else{
      const filteredData =  filterValue.includes(item[itemKey]);  
      return filteredData;
    }    
  }

  tableDataGetList(from:string,enclosingObj:any) { 
    this.appService.isLoading=true;
    if(from === 'carrier'){
      this.httpService.getCarrierDetails()
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res.length > 0) {
          res = res.filter((item: any) => item.IsActive ===true).map((item: any) => ({...item, Selected: false}));
          enclosingObj.dataSource =new MatTableDataSource<CARRIER_TABLE_INTERFACE>(res);
          enclosingObj.actualData = new MatTableDataSource<CARRIER_TABLE_INTERFACE>(res);
          enclosingObj.dataSource.sort = enclosingObj.sort;
          enclosingObj.dataSource.paginator = enclosingObj.paginator;
          this.getScvreenColumnList('Carrier',enclosingObj)
          this.checkWithFilter(this);
        }
        else{
          enclosingObj.dataSource =new MatTableDataSource<CARRIER_TABLE_INTERFACE>();
          enclosingObj.actualData = new MatTableDataSource<CARRIER_TABLE_INTERFACE>();
        }
      })
    }
    if(from === 'contact'){
      this.appService.isLoading = true;
      this.httpService.getContactDetails()
        .subscribe((res: any) => {
          this.appService.isLoading = false;
          if (res.length > 0) {
            res = res.filter((item: any) => item.IsActive ===true).map((item: any) => ({...item, Selected: false}));
            enclosingObj.dataSource = new MatTableDataSource<CONTACT_TABLE_INTERFACE>(res);
            enclosingObj.actualData = new MatTableDataSource<CONTACT_TABLE_INTERFACE>(res);
            enclosingObj.dataSource.sort = enclosingObj.sort;
            enclosingObj.dataSource.paginator = enclosingObj.paginator;
            this.getScvreenColumnList('Contact',enclosingObj)
            this.checkWithFilter(this);
          }
          else{
            enclosingObj.dataSource = new MatTableDataSource<CONTACT_TABLE_INTERFACE>();
            enclosingObj.actualData = new MatTableDataSource<CONTACT_TABLE_INTERFACE>();
          }
        })
    }

    if(from === 'bidpack'){
      this.appService.isLoading = true;
      this.httpService.getBidpackDetails()
        .subscribe((res: any) => {
          this.appService.isLoading = false;
          if (res.length > 0) {
            res = res.filter((item: any) => item.IsActive ===true).map((item: any) => ({...item, Selected: false}));
            res.forEach((item:any) => {
              const originCountryArray = item.OriginCountry.split(',');
              const uniqueOriginCountryArray = [...new Set(originCountryArray)];
              item.OriginCountry = uniqueOriginCountryArray.join(',');
            });
            enclosingObj.dataSource = new MatTableDataSource<BIDPACK_TABLE_INTERFACE>(res);
            enclosingObj.actualData = new MatTableDataSource<BIDPACK_TABLE_INTERFACE>(res);
            enclosingObj.dataSource.sort = enclosingObj.sort;
            enclosingObj.dataSource.paginator = enclosingObj.paginator;
            this.getScvreenColumnList('BidPack',enclosingObj)
            this.checkWithFilter(this);
          }
          else{
            enclosingObj.dataSource = new MatTableDataSource<BIDPACK_TABLE_INTERFACE>();
            enclosingObj.actualData = new MatTableDataSource<BIDPACK_TABLE_INTERFACE>();
          }
        })
    }

    if(from === 'fuel-escalator'){
      this.appService.isLoading = true;
      this.httpService.getEscalatorDetails()
        .subscribe((res: any) => {
          this.appService.isLoading = false;
          if (res.length > 0) {
            res = res.filter((item: any) => item.IsActive ===true).map((item: any) => ({...item, Selected: false}));
            enclosingObj.dataSource = new MatTableDataSource<FUEL_ESCALATOR_TABLE_INTERFACE>(res);
            enclosingObj.actualData = new MatTableDataSource<FUEL_ESCALATOR_TABLE_INTERFACE>(res);
            enclosingObj.dataSource.sort = enclosingObj.sort;
            enclosingObj.dataSource.paginator = enclosingObj.paginator;
            this.getScvreenColumnList('FuelEscalator',enclosingObj)
            this.checkWithFilter(this);
          }
          else{
            enclosingObj.dataSource = new MatTableDataSource<FUEL_ESCALATOR_TABLE_INTERFACE>();
            enclosingObj.actualData = new MatTableDataSource<FUEL_ESCALATOR_TABLE_INTERFACE>();
          }
        })
    }

    if(from === 'fuel-price'){
      this.appService.isLoading = true;
      this.httpService.getPriceCountry(enclosingObj.dataPriceSource?.FuelEscalatorID || 0)
        .subscribe((res: any) => {
          this.appService.isLoading = false;
          if (res.length > 0) {
            res = res.map((item: any) => ({...item, Selected: false, IncludeTax: item.IncludeTax, UserEmail: enclosingObj.userData.Email}));
            enclosingObj.dataSource = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>(res);
            enclosingObj.actualData = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>(res);
            enclosingObj.dataSource.sort = enclosingObj.sort;
            enclosingObj.dataSource.paginator = enclosingObj.paginator;
            this.checkWithFilter(this);
          }
          else{
            enclosingObj.dataSource = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>();
            enclosingObj.actualData = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>();
          }
        })
    }

    if(from === 'rate-agreement'){
      enclosingObj.dataSource = new MatTableDataSource<RATE_AGREEMENT_TABLE>();
      this.appService.isLoading = true;
      this.httpService.getAgreementDetails('all', this.appService.mineBtnEbaled? enclosingObj.userData.Email:"all")
        .subscribe((res: any) => {
          this.appService.isLoading = false;
          res = res.filter((item: any) => item.IsActive ===true).map((item: any) => ({...item, Selected: false}));
          if (res.length > 0) {
            enclosingObj.dataSource = new MatTableDataSource<RATE_AGREEMENT_TABLE>(res);
            enclosingObj.actualData = new MatTableDataSource<RATE_AGREEMENT_TABLE>(res);
            if(this.appService.mineBtnEbaled){//36,39
              enclosingObj.dataSource.data = enclosingObj.dataSource.data.filter((item: any) => ((item.RoleID === 4)&&(item.RateAgreementStatusID === 36 || item.RateAgreementStatusID === 39)));
            }
            enclosingObj.dataSource.sort = enclosingObj.sort;
            enclosingObj.dataSource.paginator = enclosingObj.paginator;
            this.getScvreenColumnList('RateAgreement',enclosingObj)
            this.checkWithFilter(this);
          }
          else{
            enclosingObj.dataSource = new MatTableDataSource<RATE_AGREEMENT_TABLE>();
            enclosingObj.actualData = new MatTableDataSource<RATE_AGREEMENT_TABLE>();
          }
          this.getScvreenColumnList('RateAgreement',enclosingObj)
          enclosingObj.dataSource.matPaginator = enclosingObj.matPaginator;
        })
    }

  }

  announceSortChange(enclosingObj:any,sortState: Sort, key:string='Status') {  
   // ------commenting this below code to avoid the filter issue while sorting
    
    // if(sortState.direction === '' && key !== ''){
    //   const filter = enclosingObj.contactTableForm.get(key+"Filter")?.value;
    //   const filteredData = enclosingObj.actualData.data.filter((item:any) => filter.includes(item[key]));
    //   console.log("filteredData",filteredData);
      
    //   enclosingObj.dataSource= new MatTableDataSource(filteredData);
    //   enclosingObj.dataSource.paginator = enclosingObj.paginator;
    //   return;
    // }
    // Perform case-insensitive sorting
    const sortedData = enclosingObj.dataSource.data.slice().sort((a:any, b:any) => {
      if(typeof(a[sortState.active]) === 'number'){
        const propertyA = a[sortState.active];
        const propertyB = b[sortState.active];
        if (propertyA < propertyB) {
          return sortState.direction === 'asc' ? -1 : 1;
        } else if (propertyA > propertyB) {
          return sortState.direction === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      }
      else{
        const propertyA = a[sortState.active]?.toLowerCase();
        const propertyB = b[sortState.active]?.toLowerCase();
    
        if (propertyA < propertyB) {
          return sortState.direction === 'asc' ? -1 : 1;
        } else if (propertyA > propertyB) {
          return sortState.direction === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      }
      
    });
    
    enclosingObj.dataSource.data = sortedData;
    enclosingObj.dataSource= new MatTableDataSource(sortedData);
    enclosingObj.dataSource.paginator = enclosingObj.paginator;
  
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  announceSortChange1(enclosingObj:any,sortState: Sort) {
    
    enclosingObj.dataSource.sort((a:any, b:any) => {
      const propertyA = a[sortState.active].toLowerCase();
      const propertyB = b[sortState.active].toLowerCase();
  
      if (propertyA < propertyB) {
        return sortState.direction === 'asc' ? -1 : 1;
      } else if (propertyA > propertyB) {
        return sortState.direction === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  getDisabledDates(startDate: Date, endDate: Date): Date[] {
    const disabledDates: Date[] = [];
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      disabledDates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return disabledDates;
  }

  createFilter(i: string) {

    if (['CreatedOn', 'ModifiedOn', "EffectiveDate", "ExpiryDate", "InitialContractEffectiveDate", "FuelEscalatorEffectiveDate"].includes(i)) {
      return function (data: any, filter: string): boolean {
        let searchTerms = JSON.parse(filter)
        let dataDate = data[i]
        let serachFormat = searchTerms[i]?searchTerms[i]?.split('-').reverse().join('/'):''
        let searchTermDate = serachFormat
        return dataDate === searchTermDate;
      }
    }
    
    let filterFunction = function (data: any, filter: string): boolean {
      const searchTerms = JSON.parse(filter);
      const dataValue = data[i] ? data[i] : data[i] === 0 ? 0 : '';
      const searchTermValue = searchTerms[i] || '';
      
      if (!((''+dataValue).trim()) && !searchTermValue.trim()) { // and operator ignore the empty
        return true; // Handle empty values, including "" and null
      }
      const dataString = dataValue.toString().toLowerCase();
      const searchTermString = searchTermValue.toString().toLowerCase();      
      return dataString.indexOf(searchTermString) !=-1;
    };
  
    return filterFunction;
  }

  handleDateSearch(input:any) {    
    let dateRegex = /^\d{2}\/\d{2}\/\d{4}$/; // Matches DD/MM/YYYY format
    if (dateRegex.test(input)) {
      let val = input.split("/").reverse().join("-")      
        return val; // Already in DD/MM/YYYY format
    } 
    else  if (input === 'true') {      
      return true;
    }
    else  if (input === 'false') {
      return false;
    }
    else{
        // Additional checks can be added here if necessary
        return ""+input;
    }
}

  //over all search above table
  searchApplyFilter(filterValue: any,enclosingObj:any) { 
    let filter = filterValue.value.trim().toLowerCase();
    if(filter === 'false' || filter ==='true' || filter === 'fal' || filter === 'tru' || filter === 'fals'){
      // enclosingObj.dataSource.filterPredicate = (data: any, filter: string) => {
      //   const autoExtensionFlag = data.AutoExtensionFlag.toString().toLowerCase();
      //   const dateFilter = this.handleDateSearch(filter);
      //   return autoExtensionFlag.includes(dateFilter);
      // };
      enclosingObj.dataSource.filter = this.handleDateSearch('000000000000000');
      return;
    }
  else{    
    enclosingObj.dataSource.filter = this.handleDateSearch(filter);
  }

  // enclosingObj.dataSource.filter = filter;
  if (enclosingObj.dataSource.paginator) {
    enclosingObj.dataSource.paginator.firstPage();
  }
  }

  onSelectChange(str: any, i: any,enclosingObj:any) {      
    // enclosingObj.dataSource.data = this.prevDataSource
    // if (i.value === 'all') {
    //   this.dateFromat(enclosingObj)
    //   return;
    // }
    // let testData = enclosingObj.dataSource.data.filter((item: any) => {
    //   return (""+item[str]).toLowerCase() == (""+i.value).toLowerCase();
    // })
    // enclosingObj.dataSource.data = [...testData];
    // this.dateFromat(enclosingObj)
  }

  onReset(enclosingObj:any, screen:string) {
    enclosingObj.contactTableForm.reset();
    enclosingObj.matSelect.value = null;
    if(screen === "bidpack"){
      enclosingObj.dataSource =new MatTableDataSource<BIDPACK_TABLE_INTERFACE>(enclosingObj.actualData.data);
    }
    else if(screen === "carrier"){
      enclosingObj.dataSource =new MatTableDataSource<CARRIER_TABLE_INTERFACE>(enclosingObj.actualData.data);
    }
    else if(screen === "contact"){
      enclosingObj.contactType.value = null;
      enclosingObj.dataSource =new MatTableDataSource<CONTACT_TABLE_INTERFACE>(enclosingObj.actualData.data);
    }
    else if(screen === "fuel-escalator"){
      enclosingObj.dataSource =new MatTableDataSource<FUEL_ESCALATOR_TABLE_INTERFACE>(enclosingObj.actualData.data);
    }
    else if(screen === "rate-agreement"){
      enclosingObj.dataSource =new MatTableDataSource<RATE_AGREEMENT_TABLE>(enclosingObj.actualData.data);
    }
    enclosingObj.searchInput.nativeElement.value = '';
    enclosingObj.dataSource.sort = enclosingObj.sort;
    enclosingObj.dataSource.paginator = enclosingObj.paginator;
  }

  checkOnInvalidDate(date:any,boo=false){    
    if(date){
      let val = date.split('T')[0];
      let rev = val.split('-').reverse().join('/');
      if(boo){
        return rev;
      }
      return rev+" "+date.split('T')[1].split('.')[0]
    }
    else
    return''
    
  }

  matDatePicker(picker:any,name:string){
    picker.open();
  }

  onBPRegion(item:any, key:string){  
    const originCountryArray = item[key] === null?'':item[key].split(',').filter((value:any) => value.trim() !== '');
    const uniqueOriginCountryArray = [...new Set(originCountryArray)];
    return uniqueOriginCountryArray.join(',');
  }

  onPageChange(event: PageEvent,enclosingObj:any, screen:string) {    
    // if (screen === 'rateTable') {
    //   this.rateTablePageCount = event.pageSize;
    // } else if (screen === 'fuelEsltr') {
    //   this.fuelEsltrPageCount = event.pageSize;
    // }else if (screen === 'editfuelEsltr') {
    //   this.editfuelEsltrPageCount = event.pageSize;
    // } else if (screen === 'bipack') {
    //   this.bipackPageCount = event.pageSize;
    // } else if (screen === 'carrier') {
    //   this.carrierPageCount = event.pageSize;
    // } else if (screen === 'contact') {
    //   this.contactPageCount = event.pageSize;
    // }
    enclosingObj.currentPage = event.pageIndex;
    enclosingObj.pageSize = event.pageSize;
  }

  goToPage(enclosingObj:any): void {
    const pageIndex = enclosingObj.goToPageNumber - 1;
    enclosingObj.paginator.pageIndex = pageIndex;
    enclosingObj.paginator._changePageSize(enclosingObj.paginator.pageSize);
  }

  onViewEditItem(action: string, item: any = null, from:string,id:any, enclosingObj:any) {
    if(item){
      let selected = enclosingObj.actualData.data.find((i:any)=> i[id] === item[id]);
      this.router.navigateByUrl(`home/${from}/edit-${from}`, { state: { operation: action, data: selected } })
    }
    else
    this.router.navigateByUrl(`home/${from}/edit-${from}`, { state: { operation: action, data: item } })
  }

  onCustomColmn(screen:string, listArray:any,enclosingObj:any) {
    const dialogRef = this.dialog.open(FilerOverlayComponent, {
      disableClose: false,
      data: { screen: screen , value:[...listArray]}
    });
    dialogRef.afterClosed().subscribe(evt => {
      if(evt.operation === "save"){
        this.getScvreenColumnList(screen,enclosingObj)
      }
    })
  }

  getTableColNames(colArr:any){
    let arr = colArr
    .filter((i:any)=>(i.selected)||(i.orderId ===0))
    .sort((a:any, b:any) => a.orderId - b.orderId)
    .map((col:any)=>col.name)    
    arr.sort((a:any, b:any) => {
      if (a === 'action') { return 1; } 
      else if (b === 'action') { return -1; } 
      else { return 0; }
    });
    return arr;
  }

  getScvreenColumnList(screen:string,enclosingObj:any){    
    let tempArr:any=[]
    if(screen === 'Carrier'){
      tempArr = [...CARRIER_DISPLAY_AGREEMENT_COLUMNS];
    }
    else if(screen === 'Contact'){
      tempArr = [...CONTACT_DISPLAY_AGREEMENT_COLUMNS];
    }
    else if(screen === 'BidPack'){
      tempArr = [...BIDPACK_DISPLAY_AGREEMENT_COLUMNS];
    }
    else if(screen === 'RateAgreement'){
      tempArr = [...DISPLAY_AGREEMENT_COLUMNS];
    }
    else if(screen === 'FuelEscalator'){
      tempArr = [...FUEL_ESCALATOR_COLUMN_LIST];
    }
    this.httpService.getColumnList(enclosingObj.userData?.UserID, screen)
    .subscribe((res: any) => {
      if (res) {
        tempArr.forEach((ele:any) => ele.selected = false) // nullfying before aasigning
        res.forEach((item:any)=>{  
          this.appService.isLoading=false;
          tempArr.find((i:any)=> {
            if(i.name === item.ColumnName){
                i.selected = item.IsActive
                i.orderId = item.ScreenColumnOrderNo
                i.ScreenColumnID = item.ScreenColumnID
                i.ScreenID = item.ScreenID
            }
          })
        })
        enclosingObj.displayedColumns=tempArr;
        this.displayColumUpdate.emit(screen)
      }
    });
  }

  selectAllItem(enclosingObj:any) {
    enclosingObj.allSelected = !enclosingObj.allSelected;
    enclosingObj.dataSource.data.forEach((item: any) => {
      item.Selected = enclosingObj.allSelected;
    });
    enclosingObj.dataSource = new MatTableDataSource(enclosingObj.dataSource.data);  
    enclosingObj.dataSource.sort = enclosingObj.sort;
    enclosingObj.dataSource.paginator = enclosingObj.paginator;  
  }

  dateFromat(enclosingObj:any){
    enclosingObj.dataSource.data = enclosingObj.dataSource.data.map((obj:any)=> {
      const createdOn = new Date(obj.CreatedOn).toLocaleDateString('en-GB');
      const modifiedOn = new Date(obj.ModifiedOn).toLocaleDateString('en-GB');
      return {
        ...obj,
        CreatedOn: createdOn,
        ModifiedOn: modifiedOn
      };
    });
  }

  onResetDate(){
    let dateArr = document.getElementsByClassName('dateFilter');
    Array.from(dateArr).forEach((element:any) => {
      element.value =''
    });
  }

  selectItem(evt:any, enclosingObj:any, from:string) {
    if(from === 'carrier'){
      enclosingObj.dataSource.data.find((item:any)=>{
        if(""+item.CarrierID == evt.id){
          item.Selected = !item.Selected
        }
      });
      enclosingObj.allSelected = enclosingObj.dataSource.data.every((item:any) => item.Selected);
    }
    if(from === 'contact'){
      enclosingObj.dataSource.data.find((item:any)=>{
        if(""+item.ContactID == evt.id){
          item.Selected = !item.Selected
        }
      });
      enclosingObj.allSelected = enclosingObj.dataSource.data.every((item:any) => item.Selected);
    }

    if(from === 'bidpack-origin'){
      enclosingObj.dataSource.data[evt].Selected = !enclosingObj.dataSource.data[evt].Selected;
      enclosingObj.allSelected = enclosingObj.dataSource.data.every((item:any) => item.Selected);
    }

    if(from === "bidpack"){
      enclosingObj.dataSource.data.find((item:any)=>{
        if(""+item.BidPackID == evt.id){
          item.Selected = !item.Selected
        }
      });
      enclosingObj.allSelected = enclosingObj.dataSource.data.every((item:any) => item.Selected);
    }

    if(from === "fuel-escalator"){
      enclosingObj.dataSource.data.find((item:any)=>{
        if(""+item.FuelEscalatorID == evt.id){
          item.Selected = !item.Selected
        }
      });
      enclosingObj.allSelected = enclosingObj.dataSource.data.every((item:any) => item.Selected);
    }

    if(from === "fuel-price"){
      enclosingObj.dataSource.data[evt].Selected = !enclosingObj.dataSource.data[evt].Selected;
      enclosingObj.allSelected = enclosingObj.dataSource.data.every((item:any) => item.Selected);
    }

    if(from === "rate-agreement"){
      enclosingObj.dataSource.data.find((item:any)=>{
        if(""+item.RateAgreementID == evt.id){
          item.Selected = !item.Selected
        }
      });
      enclosingObj.allSelected = enclosingObj.dataSource.data.every((item:any) => item.Selected);
    }
  }

  exportToExcel(data: any[],column_order:any[], fileName: string): void {
    const reorderData = (data:any, column_order:any) => {
      const orderedKeys = column_order.sort((a:any, b:any) => a.order - b.order)
      return data.map((item:any) => {
        const reorderedItem = Object.assign({});
        orderedKeys.forEach((key:any) => {
          reorderedItem[key.displayName] = item[key.name]
        });
        return reorderedItem;
      });
    };
    // Reorder the data
    const reorderedData = reorderData(data, column_order);
    // Create a worksheet from the data
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(reorderedData,{
      header: Object.values(column_order.map(data=>data.displayName))
    });
    const range = ['A1', 'B1', 'C1'];

    // Apply styles to the specified range
    range.forEach(cellAddress => {
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        fill: { fgColor: { rgb: "FFFF00" } }, // Yellow background
        font: { bold: true, color: { rgb: "FF0000" } } // Red font color
      };
    });
    // Create a new workbook and append the worksheet
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const colWidths = this.calculateColumnWidths(data);

    // Assign column widths to the worksheet
    worksheet['!cols'] = colWidths;
    // Write the workbook to a file
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

  // exportToExcel(data: any[], column_order: any[], fileName: string): void {
  //   const reorderedData = this.reorderData(data, column_order);
  //   const workbook = new Workbook();
  //   const sheet = workbook.addWorksheet('Sheet1');

  //   // Write column headers
  //   const headers = column_order.map((column: any) => column.displayName);
  //   sheet.addRow(headers);

  //   // Write data rows
  //   reorderedData.forEach((row: any) => {
  //     const values = column_order.map((column: any) => row[column.name]);
  //     sheet.addRow(values);
  //   });

  //   // Apply styles to the header row
  //   const headerRow = sheet.getRow(1);
  //   headerRow.eachCell((cell:any, colNumber:any) => {
  //     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
  //     cell.font = { bold: true, color: { argb: 'FF0000' } };
  //   });

  //   // Auto-fit column widths
  //   sheet.columns.forEach((column:any) => {
  //     const maxLength = column.values.reduce((acc:any, value:any) => Math.max(acc, String(value).length), 0);
  //     column.width = maxLength < 10 ? 10 : maxLength + 2;
  //   });

  //   // Export the workbook to Excel file
  //   workbook.xlsx.writeBuffer().then((buffer:any) => {
  //     saveAs(buffer, `${fileName}.xlsx`);
  //   });
  // }

  // private reorderData(data: any[], column_order: any[]): any[] {
  //   const orderedKeys = column_order.sort((a: any, b: any) => a.order - b.order);
  //   return data.map((item: any) => {
  //     const reorderedItem: any = {};
  //     orderedKeys.forEach((key: any) => {
  //       reorderedItem[key.displayName] = item[key.name];
  //     });
  //     return reorderedItem;
  //   });
  // }
  

  private calculateColumnWidths(data: any[]): { wch: number }[] {
    const colWidths:any = [];

    // Iterate over each key in the first object to initialize the column widths
    const keys = Object.keys(data[0]);
    keys.forEach(key => {
      colWidths.push({ wch: key.length }); // Start with the header length
    });

    // Iterate over each row to find the maximum width for each column
    data.forEach(row => {
      keys.forEach((key, index) => {
        const cellValue = row[key] ? row[key].toString() : '';
        const cellLength = cellValue.length;
        if (colWidths[index].wch < cellLength) {
          colWidths[index].wch = cellLength;
        }
      });
    });

    return colWidths;
  }

  deleteItem(screen:string,name:string,id:any,enclosingObj:any){
    const dialogRef = this.dialog.open(DeleteWarningComponent, {
      disableClose: false,
      data: { header: `Delete ${screen}`, msg: `Are you sure you want to delete this ${screen}?` }
    });
    dialogRef.afterClosed().subscribe((evt:any) => {
      if(evt.operation === "confirm"){
        this.appService.isLoading = true;
        let body = {
          UserID:enclosingObj.userData.UserID,
          ScreenName:screen==="Rate Agreement"?"RateAgreement":screen,
          [name]:id
        }
        this.httpService.deleteItem(body)
        .subscribe(res =>{
         this.appService.isLoading = false;
         this.httpService.openSnackBar(`${screen} Item Deleted Successfully`);
         if(screen === 'Carrier'){
          this.router.navigateByUrl('/home/carrier')
         }
         else if(screen === 'Contact'){
          this.router.navigateByUrl('/home/contact')
         }
         else  if(screen === 'Bidpack'){
          this.router.navigateByUrl('/home/bidpack')
         }
         else if(screen === 'FuelEscalator'){
          this.router.navigateByUrl('/home/fuel-escalator')
         }
         else  if(screen === 'Rate Agreement'){
          this.router.navigateByUrl('/home/rate-agreement')
         }
         else{
          this.router.navigateByUrl('/home')
         }
        })
      }
    })
  }

}
 